/**
 * Development-only logger utility.
 * Suppresses all console output in production builds.
 */

const isDev = process.env.NODE_ENV?.toLowerCase() !== 'production'

export const logger = {
  log: (...args: any[]): void => {
    if (isDev) console.log(...args)
  },
  debug: (...args: any[]): void => {
    if (isDev) console.debug(...args)
  },
  info: (...args: any[]): void => {
    if (isDev) console.info(...args)
  },
  warn: (...args: any[]): void => {
    if (isDev) console.warn(...args)
  },
  error: (...args: any[]): void => {
    // Always log errors, even in production
    console.error(...args)
  }
}
